var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('p',{staticClass:"score-label"},[_vm._v(_vm._s(_vm.scoreLabel))]),_c('div',{staticClass:"score-card"},[_vm._v(_vm._s(_vm.scoreValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }